var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.4834C12 7.68775 12.3161 6.92469 12.8787 6.36208C13.4413 5.79947 14.2044 5.4834 15 5.4834H21C21.1989 5.4834 21.3897 5.56242 21.5303 5.70307C21.671 5.84372 21.75 6.03449 21.75 6.2334V18.2334C21.75 18.4323 21.671 18.6231 21.5303 18.7637C21.3897 18.9044 21.1989 18.9834 21 18.9834H15C14.2044 18.9834 13.4413 19.2995 12.8787 19.8621C12.3161 20.4247 12 21.1877 12 21.9834",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18.2334C2.25 18.4323 2.32902 18.6231 2.46967 18.7637C2.61032 18.9044 2.80109 18.9834 3 18.9834H9C9.79565 18.9834 10.5587 19.2995 11.1213 19.8621C11.6839 20.4247 12 21.1877 12 21.9834V8.4834C12 7.68775 11.6839 6.92469 11.1213 6.36208C10.5587 5.79947 9.79565 5.4834 9 5.4834H3C2.80109 5.4834 2.61032 5.56242 2.46967 5.70307C2.32902 5.84372 2.25 6.03449 2.25 6.2334V18.2334Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/BookOpen.889fa5c145225e2eff5d2a53d0e2b2a7.svg";
export { ForwardRef as ReactComponent };